import { getGlobalSearchResults } from '../business-logic/use-cases/GetGlobalSearchResultsUseCase'

export const globalSearchResultsQueryConfig = {
  search: (query: string) => ({
    queryKey: ['global-search', 'results', query],
    queryFn: () => getGlobalSearchResults({ query }),
  }),
}
